import React, { useState, useEffect } from "react";
import LogoBg from "../../../assets/img/Logo-bg.jpg";
import Logo from "../../../assets/img/1699451121.png";
import { useLoginMutation } from "../../../Store/Apis/AuthApi";
import {
  loginReducer,
  permissionReducer,
} from "../../../Store/Slices/AuthSlice";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate, useLocation } from "react-router-dom";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const [login] = useLoginMutation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user = useSelector((state) => state.auth.user);

  // Check for success message from password reset
  useEffect(() => {
    if (location.state?.message) {
      setSuccessMessage(location.state.message);
      // Clear the message after showing it
      setTimeout(() => setSuccessMessage(""), 5000);
    }
  }, [location.state]);

  // Redirect if authenticated
  if (isAuthenticated) {
    // Check if user is a beverage coordinator (role_Id: 7)
    if (user && user.role_Id === 7) {
      return <Navigate to="/mobile-dashboard" />;
    }
    return <Navigate to="/dashboard" />;
  }

  // Simple validation function
  const validateForm = () => {
    if (!email || !password) {
      setError("Both fields are required");
      return false;
    }

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(email)) {
      setError("Invalid email address");
      return false;
    }
    setError("");
    return true;
  };

  // Fetch permissions using fetch API
  const fetchPermissionsByRoleId = async (roleId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/Auth/RoleAndPermissionByID?id=${roleId}`
      );
      if (response.ok) {
        const data = await response.json();
        dispatch(permissionReducer(data.data.permissions));
      } else {
        console.error("Failed to fetch permissions");
      }
    } catch (err) {
      console.error("Error fetching permissions:", err);
    }
  };

  // Handle login submission
  const handleLogin = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      const response = await login({ username: email, password: password });
      console.log(response);
      if (response?.data?.status === 200) {
        // Check if the user has outlet_Id equal to 4
        if (response.data.data.outletID === 3) {
          setError("Invalid outlet credentials. Access denied.");
        } else {
          const role_Id = response.data.data.role_Id;
          // Dispatch the login state with the user data
          dispatch(loginReducer(response.data.data));
          // Fetch permissions after successful login
          await fetchPermissionsByRoleId(role_Id);
        }
      } else if (response?.error?.status === 400) {
        setError(response?.error.data.message);
      } else if (response?.error?.status === "FETCH_ERROR") {
        setError("Error: Unable to connect to the server");
      } else if (response?.error?.originalStatus === 500) {
        setError("500 (Internal Server Error)");
      }
    } catch (err) {
      console.log(err);
      setError("Something Went Wrong !!");
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = (e) => {
    e.preventDefault();
    navigate("/forgot-password");
  };

  return (
    <div className="main-content main-content-bg mt-0 ps">
      <div
        className="page-header min-vh-100"
        style={{ backgroundImage: `url(${LogoBg})` }}
      >
        <span className="mask bg-gradient-dark opacity-6"></span>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-6">
              <div className="card border-0 mb-0">
                <div className="card-header text-center pt-4 pb-2 bg-transparent">
                  <img src={Logo} className="login-logo" alt="Logo" />
                </div>
                <div className="card-body px-lg-5">
                  <h1 className="fs-5 text-muted mb-3 fw-normal">
                    Login to Continue
                  </h1>
                  <form onSubmit={handleLogin}>
                    <div className="form-group mb-2">
                      <label>Email address</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-1">
                      <label>Password</label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </div>
                    <div>
                      <a
                        href="#"
                        onClick={handleForgotPassword}
                        className="text-center text-primary-faded text-sm"
                      >
                        Forgot Password?
                      </a>
                    </div>
                    {successMessage && (
                      <div className="text-success text-sm mt-2">
                        {successMessage}
                      </div>
                    )}
                    {error && (
                      <div className="text-danger text-sm mt-2">{error}</div>
                    )}
                    <button
                      type="submit"
                      className="btn btn-primary mt-4 mb-4 w-100"
                      disabled={loading}
                    >
                      {loading ? "Logging in..." : "Login"}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
